module.exports = __webpack_public_path__ + "static/murat-guvenc-658d2482cfb48e56cf19262f7a0cb32f.png";